import { useEffect, useMemo, useState } from 'react'
import { InputNumber, Modal } from 'antd'
import styled from 'styled-components'

export function AddMultipleLineItemsModal({
  moduleName,
  isOpen,
  onClose,
  onSubmit,
  duplicateLineItemName = null
}) {
  const [numOfNewItems, setNumOfNewItems] = useState<number | null>(2)
  let submitted = false

  const LineItemsLabel = useMemo(
    () => (moduleName.toLowerCase() === 'delivery' ? 'products' : 'items'),
    [moduleName]
  )

  const modalTitle = useMemo(
    () =>
      duplicateLineItemName
        ? `Duplicate multiple ${LineItemsLabel}`
        : `Add multiple ${LineItemsLabel}`,
    [LineItemsLabel, duplicateLineItemName]
  )

  useEffect(() => {
    if (!isOpen) {
      setNumOfNewItems(2)
    }
  }, [isOpen])

  const handleChange = (value: number | null) => {
    setNumOfNewItems(value)
  }

  const handleOnOK = () => {
    if (!submitted) {
      submitted = true
      onSubmit(numOfNewItems)
      onClose()
    }
  }

  const submitOnEnter = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      handleOnOK()
    }
  }

  return (
    <Modal
      title={modalTitle}
      open={isOpen}
      onCancel={onClose}
      onOk={handleOnOK}
      width={'25rem'}
    >
      <p>Select how many new {LineItemsLabel} you want to add and click OK.</p>
      {duplicateLineItemName && (
        <p>
          These new {LineItemsLabel} will be duplicates of:
          <br />
          <b>{duplicateLineItemName}</b>
        </p>
      )}
      <CenteredDiv>
        <label>
          New {LineItemsLabel}:{' '}
          <InputNumber
            onChange={handleChange}
            value={numOfNewItems}
            max={100}
            onKeyDown={submitOnEnter}
          />
        </label>
      </CenteredDiv>
    </Modal>
  )
}

const CenteredDiv = styled.div`
  text-align: center;
`
